import { DisputesApiBase } from './paymentApi';

class DisputeApi extends DisputesApiBase {

}

export default new DisputeApi();
